import Axios from 'axios';


export default {
  getAll(url) {
    return Axios.get(url);
  },
  getAllWithHeader(url,headers) {
    return Axios.get(url,headers);
  },

  get(url,id) {
    return Axios.get(`${url}/${id}`)
  },
  getAllWithHeaderAndData(url,id,headers) {
    return Axios.get(`${url}/${id}`,headers)
  },

  post(url,data) {
    return Axios.post(url, data)
  },
  postWithHeader(url,data,headers) {
    return Axios.post(url,data, headers)
  },

  moodelPost(url,data) {
    return Axios.post(url, data)
  },

  update(url, id, data) {
    return Axios.put(`${url}/${id}`, data)
  },

  delete(url,id) {
    return Axios.delete(`${url}/${id}`)
  }
};